export default "/images/vendor/@coreui/icons/svg/flag/cif-bh.svg?9e3fa266bc4e86cac08382bfc0424915";